import React, { useEffect, useState } from 'react'
import { Button, Card, CardContent, Grid, Typography } from '@mui/material'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import Input from 'components/forms/Input'
import NoteAddIcon from '@mui/icons-material/NoteAdd'
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined'
import ParamTraitementSynchroImport from './ParamTraitementSynchroImport'
import JobAction from 'import/actions/JobAction'
import { entries, omit } from 'lodash'
import ReferencialAction from 'referencial/action/ReferencialAction'
import { reloadJobSync } from 'referencial/util/ReferencialUtils'
import { useDispatch } from 'react-redux'
import JobSyncStatus from '../../../referencial/components/JobSyncStatus'
import { getFullDate } from 'utils/DateUtil'


const TraitementSynchroStartCard = ({
    params,
    title,
    insertAllDataBanq,
    data,
}) => {
    const param = JSON.parse(data.parameters)
    const [jobSync, setJobSync] = useState()
    const dispatch = useDispatch()
    const omitValue = ['updates', 'inserts', 'progress']

    const save = () => {
        entries(params.pairToSaveSynchro).forEach(([jobtype, dataa]) => {
            if (param.jobType === jobtype) {
                dataa.dispatch(JobAction.updateJob({
                    ...dataa.initialJob,
                    jobType: jobtype,
                    parameters: dataa.initialJob.parameters,
                }, false))
            }
        })
    }

    const reloadJobSyncWithoutDetails = () => {
        reloadJobSync(data.id, job => {
            const jobSyncWithoutDetails = omit(job, omitValue)
            setJobSync(jobSyncWithoutDetails)
        })
    }

    const launch = () => {
        dispatch(ReferencialAction.launchSyncJob(data.id, { insertAllDataBanq: true }, () => () => reloadJobSyncWithoutDetails()))
    }


    useEffect(() => {
        JobAction.promiseFullJob(data.id, 1).then(job => {
            if (job?.executions?.[0]) {
                setJobSync({ ...job, exec: job.executions[0] })
            }
        })
    }, [data.id])

    useEffect(() => {
        if (!jobSync?.exec || jobSync.exec.endDate) {
            return () => {}
        }

        const interval = setInterval(() => {
            reloadJobSyncWithoutDetails()
        }, 2000)

        return () => {
            clearInterval(interval)
        }
    }, [jobSync, data.id])


    return (
        <Card>
            <CardContent>
                <Grid container spacing={3} alignItems='center'>
                    <Grid size={2}>
                        <Input
                            title={i18n.name}
                            fullWidth
                            value={title}
                        />
                    </Grid>
                    <Grid size={10}>
                        <ParamTraitementSynchroImport
                            {...params}
                            valid={false}
                            data={data}
                            insertAllDataBanq={insertAllDataBanq}
                        />
                    </Grid>
                    <Grid size={2}>
                        <Button
                            variant='contained'
                            startIcon={<NoteAddIcon/>}
                            onClick={save}
                        >
                            {i18n.save}
                        </Button>
                    </Grid>
                    <Grid container offset={7} size={2} alignItems='center'>
                        {jobSync?.exec ? (
                            <JobSyncStatus
                                jobSync={jobSync}
                                smallMode
                            />
                        ) : (
                            <Typography
                                variant='caption'
                                sx={{ color: 'black', fontStyle: 'italic' }}
                            >
                                {i18n.updatedOn}
                                {getFullDate(data.updateDate)}
                            </Typography>
                        )}
                    </Grid>
                    <Grid size={1}>
                        <Button
                            variant='contained'
                            startIcon={<PlayCircleFilledWhiteOutlinedIcon/>}
                            onClick={launch}
                        >
                            {i18n.launch}
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}


TraitementSynchroStartCard.propTypes = {
    title: PropTypes.string,
    insertAllDataBanq: PropTypes.any,
    params: PropTypes.any,
    data: PropTypes.objet,
}

export default TraitementSynchroStartCard